import { Link, Navigate, useSearchParams } from "react-router-dom";
import AdminLayout from "../../../components/AdminLayout";
import { Cabecalho, Pagina } from "../../../components/AdminLayout/Pagina";
import Relatorio from "../../../../models/Relatorio";
import { numero, useRelatorio } from "../../Relatorios/useRelatorio";
import { Cartoes } from "./styled";
import { caminhoLista, ORDEM, RECURSOS } from "./recursos";

// Endereços antigos desta tela eram abas (?aba=especies). Continuam valendo:
// favoritos e links compartilhados vão para a página do item. A aba "formulario"
// (link do formulário do apoiador) deixou de existir: o pedido de apoio é feito pelo
// app e aprovado em Pedidos. Esse endereço antigo cai no índice.
const ABAS_ANTIGAS = [...ORDEM, "formulario"];

// Índice do conteúdo: cada cartão leva à página PRÓPRIA daquele cadastro, onde a
// lista ocupa a tela inteira, com busca, adição, edição e exclusão.
export default function Conteudo() {
  const [params] = useSearchParams();
  const aba = params.get("aba");
  const antiga = ABAS_ANTIGAS.includes(aba);

  // O resumo só é consultado quando a página de fato aparece.
  const resumo = useRelatorio(Relatorio.resumo, {}, !antiga);

  if (antiga) {
    return <Navigate to={aba === "formulario" ? "/admin/conteudo" : caminhoLista(aba)} replace />;
  }

  const plataforma = resumo.dados?.plataforma;

  return (
    <AdminLayout>
      <Pagina>
        <Cabecalho titulo="Conteúdo" descricao="Cadastros que aparecem no site e no app. Escolha um para ver a lista, buscar, adicionar, editar ou excluir. Usuários e Pedidos têm páginas próprias." />

        <Cartoes aria-label="Cadastros de conteúdo" aria-busy={resumo.carregando}>
          {ORDEM.map((id) => {
            const r = RECURSOS[id];
            const total = plataforma?.[r.resumo];
            return (
              <div key={id} className="celula">
                <Link to={caminhoLista(id)} className="cartao">
                  <h3>{r.titulo}</h3>
                  <p>{r.descricao}</p>
                  <span className="numero">
                    {resumo.carregando ? "…" : total == null ? "—" : numero(total)}
                    <small>{total == null ? "" : total === 1 ? "cadastrado" : "cadastrados"}</small>
                  </span>
                  <span className="abrir">Abrir lista →</span>
                </Link>
                {/* Um cartão inteiro é um link; o atalho fica FORA dele (link dentro de link é inválido). */}
                {r.atalho && <Link to={r.atalho.para} className="atalho">{r.atalho.rotulo}</Link>}
              </div>
            );
          })}
        </Cartoes>
      </Pagina>
    </AdminLayout>
  );
}
